import { css } from "@emotion/css";

import { yellow } from "@/modules/theme/utils/colors";
import { Theme } from "@/modules/theme/utils/createTheme";

export const createTutorialsPageStyles = ({ spacing }: Theme) => {
  return {
    root: css({
      position: "relative",
    }),
    heading: css({
      marginBottom: spacing(3),
    }),
    loaderWrapper: css({
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      color: yellow[400],
      width: "100%",
      height: 400,
    }),
    emptyListText: css({
      textAlign: "center",
      marginBottom: spacing(2),
    }),
    levelTutorialsWrapper: css({
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "center",
      margin: spacing([2, 0]),
    }),
  };
};
